import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

// docs: https://formatjs.io/docs/react-intl/components/#formattedmessage

const InjectMassage = (props) => <FormattedMessage {...props} />;
export default injectIntl(InjectMassage, {
	withRef: false,
});
